import { HubletOption } from 'signup-constants/signupData/HubletOption';
import { getApplicationDomain } from '../constants/apiEnvironments';
export const getPortalHomeUrl = (portalId, hublet = HubletOption.na1) => {
  return `${getApplicationDomain(hublet)}/home?portalId=${portalId}`;
};